// src/features/universalsearcher/universalsearcherSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storedvalues: [
    { id: 'tov', value: '' }, 
    { id: 'lov', value: 0 },
    { id: 'tov2', value: '' }, 
    { id: 'lov2', value: 0 },
  ],
};

const Dump = createSlice({
  name: 'dump',
  initialState,
  reducers: {
    updateTovValue: (state, action) => {
      const item = state.storedvalues.find((result) => result.id === 'tov');
      if (item) {
        item.value = action.payload;
      }
    },
    updatelovValue: (state, action) => {
      const item = state.storedvalues.find((result) => result.id === 'lov');
      if (item) {
        item.value = action.payload;
      }
    },
    updateTov2Value: (state, action) => {
      const item = state.storedvalues.find((result) => result.id === 'tov2');
      if (item) {
        item.value = action.payload;
      }
    },
    updatelov2Value: (state, action) => {
      const item = state.storedvalues.find((result) => result.id === 'lov2');
      if (item) {
        item.value = action.payload;
      }
    },
  },
});

// Export actions
export const { updateTovValue, updatelovValue, updateTov2Value, updatelov2Value } = Dump.actions;

// Export reducer
export default Dump.reducer;
